import { Injectable } from '@angular/core';
import { CurrentUser } from '@shared/model/currentUser.model';

import { BaseSignalStore } from '../signal-state.util';

export interface CurrentUserState {
  data: Partial<CurrentUser> | any;
}

function createInitialState(): CurrentUserState {
  return { data: {} };
}

@Injectable({ providedIn: 'root' })
export class CurrentUserStore extends BaseSignalStore<CurrentUserState> {
  constructor() {
    super(createInitialState(), { name: 'current_user' });
  }

  updateOne(payload: any): void {
    this.update((state: any) => ({
      data: { ...(state.data || {}), ...payload }
    }));
  }

  updateOrganization(payload: any): void {
    this.update((state: any) => ({
      data: {
        ...(state.data || {}),
        organization: { ...(state.data?.organization || {}), ...payload }
      }
    }));
  }

  updateGroup(payload: any): void {
    this.update((state: any) => ({
      data: {
        ...(state.data || {}),
        group: { ...(state.data?.group || {}), ...payload }
      }
    }));
  }
}
